<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Desassociar Consultoria"
            @click.stop="
                confirmarDesassociar(
                    pagamentoConsultoria.pagamentoConsultoriaId
                )
            "
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentoConsultoria: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDesassociar(pagamentoConsultoriaId) {
            this.$swal({
                title: 'Desassociação de Consultoria',
                html: `Confirma a desassociação da consultoria?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociar(pagamentoConsultoriaId)
                }
            })
        },

        desassociar(pagamentoConsultoriaId) {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .desassociarConsultoria({
                    pagamentoId: this.$route.params.pagamentoId,
                    pagamentoConsultoriaId: pagamentoConsultoriaId
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                'Erro ao desassociar etapa do pagamento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {}
}
</script>
